import Breadcrumbs from '@Components/Breadcrumbs';
import Heading from '@Components/Heading';
import PartnerReferralCodeList from './PartnerReferralCodeList';

export default function PartnerReferralCodes() {
  return (
    <div>
      <Breadcrumbs
        navList={[
          { name: 'Admin', href: '/' },
          { name: 'Partner Codes', href: '/partner-referral-codes' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Partner Codes</Heading>
        </div>
      </div>
      <PartnerReferralCodeList />
    </div>
  );
}
